import { render, staticRenderFns } from "./Prices.vue?vue&type=template&id=03d36406"
import script from "./Prices.vue?vue&type=script&lang=ts"
export * from "./Prices.vue?vue&type=script&lang=ts"
import style0 from "./Prices.vue?vue&type=style&index=0&id=03d36406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports